<nz-card class="condensed-card">
    <div class="card-header">
        <h2 style="font-weight: bold; font-size: 15px;">
            Depth: {{jobState.depth()}}
            @if(jobState.selectedLog(); as data){
                [{{data.name}}]
            }
        </h2>

        <div class="omit-from-screenshot" style="display: flex; align-items: center; gap: 10px;">
            <a (click)="resetZoom()" nz-tooltip nzTooltipTitle="Reset Zoom" style="font-size: 20px;">
                <nz-icon nzType="sync" nzTheme="outline" />
            </a>
            <button nz-button nzType="default" nzSize="small" class="settings-btn"
                nz-dropdown [nzDropdownMenu]="depthMenu" [nzClickHide]="false" nzTrigger="click">
                <nz-icon nzType="setting" nzTheme="outline" />
                Depth Settings
                <nz-icon class="settings-caret" nzType="down" nzTheme="outline" />
            </button>
        </div>
    </div>

    <div class="slice-viewer">
        @if (sliceResource.isLoading()) {
        <div class="overlay">
            <nz-spin nzSimple nzTip="Fetching Seismic Slice..." nzSize="large"></nz-spin>
        </div>
        }
        @if (sliceResource.error(); as error) {
        <div class="slice-error">
            <div>
                <nz-alert nzType="error" nzMessage="Error loading slice" [nzDescription]="error.message" nzShowIcon />
            </div>
        </div>
        }
        @if (viewerSettings.showShotOverlay() && fitInfoResource.error(); as error) {
        <div class="slice-error">
            <nz-alert nzType="error" nzMessage="Error loading Shots" [nzDescription]="error.message" nzShowIcon />
        </div>
        }
        @if (displayData(); as data) {
        <div>
            <app-my-viewer 
                #sliceViewer
                [sliceImage]="data.sliceImage" 
                [sliceArray]="data.sliceArray" 
                [colorbar]="data.colorbar"
                [limits]="limits()" 
                [xIndicator]="jobState.crossline()"
                [yIndicator]="jobState.inline()"
                [showSonicLocations]="viewerSettings.showSonicLocations()"
                [horizonDataResource]="horizonsDataResource"
                [shotsOverlay]="mergedShots()"
                [isDepth]="true"
                xLabel="Crossline"
                yLabel="Inline"
                [viewerHeight]="viewerSettings.depthViewerHeight()"
                [flippedYAxis]="false"
                [xCrop]="xCrop()"
                [yCrop]="yCrop()"
            >
            </app-my-viewer>
        </div>
        }
    </div>
    
</nz-card>



<nz-dropdown-menu #depthMenu="nzDropdownMenu">
    <ul nz-menu [nzSelectable]="false">
        <li nz-menu-item (click)="openMinMaxDialog()" class="custom-menu-item">
            <div style="flex: 1; display: flex; justify-content: space-between; align-items: center;">
                Min/Max
                <nz-icon style="color: #aaa;" nzType="export" nzTheme="outline" />
            </div>
        </li>

        <li nz-menu-divider></li>
        
        <li nz-menu-item class="custom-menu-item">
            Height
            <div style="width: 100px;">
                <nz-slider [(ngModel)]="viewerSettings.depthViewerHeight" [nzMin]="150" [nzMax]="900"
                    [nzStep]="25"></nz-slider>
            </div>
        </li>
        
        <li nz-menu-item class="custom-menu-item">
            Shot Radius
            <div style="width: 100px;">
                <nz-slider [(ngModel)]="viewerSettings.depthShotRadius" [nzMin]="1" [nzMax]="10"></nz-slider>
            </div>
        </li>

        <li nz-menu-divider></li>
        
        <li nz-menu-item class="custom-menu-item">
            Dotted Line
            <nz-switch [(ngModel)]="viewerSettings.gridLines" />
        </li>
        <li nz-menu-item class="custom-menu-item">Smoothing
            <nz-switch [(ngModel)]="viewerSettings.smoothing" />
        </li>
        <li nz-menu-item class="custom-menu-item">Show Sonic Location
            <nz-switch [(ngModel)]="viewerSettings.showSonicLocations" />
        </li>
        <li nz-menu-item class="custom-menu-item">Shot Overlay
            <nz-switch [(ngModel)]="viewerSettings.showShotOverlay" />
        </li>
        <li nz-menu-item class="custom-menu-item">Show Only Used Shots
            <nz-switch [(ngModel)]="viewerSettings.showOnlyUsedShots" />
        </li>

        <li nz-menu-divider></li>

        <li nz-submenu nzTitle="Shot Overlay Metric">
            <ul>
                <li nz-menu-item (click)="viewerSettings.selectedShotOverlayMetric.set('traces_fit')">
                    Trace fit
                </li>
                <li nz-menu-item (click)="viewerSettings.selectedShotOverlayMetric.set('dc_raw')">
                    Trace fit - Raw
                </li>
                <li nz-menu-item (click)="viewerSettings.selectedShotOverlayMetric.set('dc_twk')">
                    Trace fit - Time Tweak
                </li>
                <li nz-menu-item (click)="viewerSettings.selectedShotOverlayMetric.set('fnlc')">
                    Functionals
                </li>
                <li nz-menu-item (click)="viewerSettings.selectedShotOverlayMetric.set('sz')">
                    Depth
                </li>
            </ul>
        </li>

        <li nz-menu-item class="custom-menu-item">
            <div style="display: flex">
                <nz-form-item class="floating-label" style="margin: 0">
                    <nz-form-label for="min" [nzNoColon]="true">Shot Color Min</nz-form-label>
                    <input nz-input type="number" [(ngModel)]="viewerSettings.shotColorMin">
                </nz-form-item>
                <nz-form-item class="floating-label" style="margin: 0">
                    <nz-form-label for="min" [nzNoColon]="true">Shot Color Max</nz-form-label>
                    <input nz-input type="number" [(ngModel)]="viewerSettings.shotColorMax">
                </nz-form-item>
            </div>
        </li>
    </ul>
</nz-dropdown-menu>